import { render, staticRenderFns } from "./Uniodontos.vue?vue&type=template&id=d269a1e8&"
import script from "./Uniodontos.vue?vue&type=script&lang=js&"
export * from "./Uniodontos.vue?vue&type=script&lang=js&"
import style0 from "./Uniodontos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports